export default {
  roundtrip: {
    roundtripOptions: 'Možnosti zpáteční cesty'
  }
}
